import { render } from "./Externo.vue?vue&type=template&id=5cc868dc&scoped=true"
import script from "./Externo.vue?vue&type=script&lang=js"
export * from "./Externo.vue?vue&type=script&lang=js"

import "./Externo.vue?vue&type=style&index=0&id=5cc868dc&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc868dc"]])

export default __exports__